import { render, staticRenderFns } from "./look-up-detail.vue?vue&type=template&id=0d4b8e10&scoped=true"
import script from "./look-up-detail.vue?vue&type=script&lang=js"
export * from "./look-up-detail.vue?vue&type=script&lang=js"
import style0 from "./look-up-detail.vue?vue&type=style&index=0&id=0d4b8e10&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4b8e10",
  null
  
)

export default component.exports